import React, {Component, Fragment} from 'react';
import {cloneDeep} from "lodash";
import {Col, Modal, Row, Input, Form, Upload, Button, Select, message} from "antd";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import {ProjectOutlined, InboxOutlined, DeploymentUnitOutlined} from '@ant-design/icons';
import API from "../scripts/api";

class DeleteBarcode extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            id: '',

            deletedBarcodes:[],
            barcodes:[]
        };

        this.formRef = React.createRef();
        this.deleteBarcode = React.createRef();
    }


    handleSubmit = () => {
        let {publishRateArr} = this.state

    };

    handleWillUnmount = () => {
        this.deleteBarcode.current.resetFields();
    };

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);
        console.log(!!cloneData.id);
        this.setState({editMode: !!cloneData.id, id: cloneData.id});
        if(!!cloneData.id){
            this.setState({barcodes: cloneData.range})
            this.getDeletedBarcodes(cloneData.id)
        }
    }

    getDeletedBarcodes = (params = {}) => {
        this.setState({ loading: true });
        API.printBarcode.getDeletedBarcodes(params)
            .then((result) => {
                if (result.data) {
                    this.setState({
                        loading: false,
                        deletedBarcodes: result.data,
                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    restoreBarcode = (record) => {
        Modal.confirm({
            title: Resources.confirmDelete,
            okText: Resources.yes,
            okType: Resources.danger,
            cancelText: Resources.no,
            onOk: () => {
                this.setState({loading : true});
                API.printBarcode.restoreItemBarcode(record.id)
                    .then(res => {
                        message.success(Resources.successful);
                        this.getDeletedBarcodes(this.state.id)
                    })
                    .catch(() => {
                        this.setState({ loading: false });
                    });
            }
        });
    };


    render() {
        const {onCancel, submitting, visible} = this.props;
        const { editMode, deletedBarcodes, barcodes} = this.state;

        const deleteBarcode = (values) => {
            console.log("dd" , values)
            this.setState({ loading: true });
            API.printBarcode.deleteItemBarcode(this.state.id, values)
                .then((result) => {
                    this.setState({
                        loading: false,
                    });

                    this.getDeletedBarcodes(this.state.id)
                    this.deleteBarcode.current.resetFields();


                })
                .catch(() => {
                    this.setState({ loading: false });
                });
            console.log('Success:', values);
        };
        return (
            <Fragment>
                <Modal
                    title={ Resources.deleteSpecificBarcode}
                    visible={visible}
                    onOk={this.handleSubmit}
                    onCancel={onCancel}
                    okText={Resources.confirm}
                    cancelText={Resources.cancel}
                    okButtonProps={{loading: submitting}}
                    cancelButtonProps={{disabled: submitting}}
                    footer={null}
                    width={1000}
                    maskClosable={false}
                >

                        <div>

                            <Form ref={this.deleteBarcode} layout="vertical"   onFinish={deleteBarcode} >
                                <Row gutter={24} style={{marginTop: "3%"}}>
                                    <Col xs={24} md={24}>
                                        <Form.Item  required={true}   name="barcode" label={Resources.barcode} >
                                            <Select
                                                showSearch={true}
                                                mode="multiple"

                                            >
                                                {barcodes.map(item => (
                                                    <Select.Option  title={item.barcode}   style={{direction:"rtl"}} key={item.barcode}  value={item.barcode}>
                                                        {item.barcode }
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>



                                    <Col xs={24} md={3} style={{marginTop: "3%"}}>
                                        <Button type="primary" htmlType="submit">{Resources.delete}</Button>
                                    </Col>


                                </Row>
                            </Form>

                        </div>

                    <Form ref={this.formRef} layout="vertical">

                        {deletedBarcodes &&
                        deletedBarcodes.map(item =>(
                            <div>
                                <Row gutter={24}>
                                    <Col xs={24} md={8}>
                                        <Form.Item  name={`barcode-${item.id}`}  label={Resources.barcode} initialValue= {item.barcode}  >
                                            <Input disabled type="text" dir="rtl" />
                                        </Form.Item>
                                    </Col>

                                    <Col xs={12} md={4} style={{display: 'flex',alignItems: 'center'}}>
                                        <Button style={{width: "100%"}} loading={submitting} type='danger' onClick={() => this.restoreBarcode(item)} >
                                            {Resources.restore}
                                        </Button>
                                    </Col>

                                </Row>
                            </div>
                            )
                        )
                        }
                    </Form>

                </Modal>
            </Fragment>
        );
    }
}

export default DeleteBarcode;
